import React from 'react';
import { TimePeriod, DateRange } from '../../../types/analytics.types';
import { getCurrentTradingDay, getCurrentTradingWeek } from '../../../utils/marketHours';

interface Props {
  activePeriod: TimePeriod;
  dateRange: DateRange;
  onPeriodChange: (period: TimePeriod, range?: DateRange) => void;
  onCustomDateChange: (range: DateRange) => void;
}

const TimePeriodFilter: React.FC<Props> = ({ activePeriod, dateRange, onPeriodChange, onCustomDateChange }) => {
  const handleToday = () => {
    const { start, end } = getCurrentTradingDay();
    onPeriodChange('today', { from: start.toISOString(), to: end.toISOString() });
  };

  const handleThisWeek = () => {
    const { start, end } = getCurrentTradingWeek();
    onPeriodChange('this_week', { from: start.toISOString(), to: end.toISOString() });
  };

  const handleThisMonth = () => {
    const now = new Date();
    const from = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    const to = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
    onPeriodChange('this_month', { from, to });
  };

  const handleAllTime = () => {
    onPeriodChange('all_time', { from: '', to: '' });
  };

  return (
    <div className="analytics-filter">
      <div className="filter-buttons">
        <button
          className={`filter-btn ${activePeriod === 'all_time' ? 'active' : ''}`}
          onClick={handleAllTime}
        >
          All Time
        </button>
        <button
          className={`filter-btn ${activePeriod === 'this_month' ? 'active' : ''}`}
          onClick={handleThisMonth}
        >
          This Month
        </button>
        <button
          className={`filter-btn ${activePeriod === 'this_week' ? 'active' : ''}`}
          onClick={handleThisWeek}
        >
          This Week
        </button>
        <button
          className={`filter-btn ${activePeriod === 'today' ? 'active' : ''}`}
          onClick={handleToday}
        >
          Today
        </button>
      </div>
      <div className="filter-custom-dates">
        <label className="filter-date-label">
          From
          <input
            type="date"
            className="filter-date-input"
            value={dateRange.from}
            onChange={(e) => {
              onCustomDateChange({ ...dateRange, from: e.target.value });
            }}
          />
        </label>
        <label className="filter-date-label">
          To
          <input
            type="date"
            className="filter-date-input"
            value={dateRange.to}
            onChange={(e) => {
              onCustomDateChange({ ...dateRange, to: e.target.value });
            }}
          />
        </label>
        {(dateRange.from || dateRange.to) && activePeriod === 'custom' && (
          <button className="filter-clear-btn" onClick={handleAllTime}>Clear</button>
        )}
      </div>
    </div>
  );
};

export default TimePeriodFilter;
